/**
 * Generates a username with 32 random characters
 * @param displayName - The customer's display name (unused, kept for compatibility)
 * @returns A formatted username email address with 32 random characters
 */
export const generateUsername = (displayName: string): string => {
  const baseUsername = displayName
    .toLowerCase()
    .replace(/\s+/g, '_') // all whitespace to underscore
    .replace(/[^a-z0-9_]/g, '') // remove non-alphanumeric characters
    .replace(/_+/g, '_'); // remove consecutive underscores

  // Generate 32 random characters (valid email characters: alphanumeric, dot, hyphen, underscore)
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const randomArray = new Uint8Array(3);
  crypto.getRandomValues(randomArray);

  const randomString = Array.from(randomArray)
    .map(byte => chars[byte % chars.length])
    .join('');

  return `guard+${baseUsername}-${randomString}@praetorian.com`;
};
